import React, { useState, useEffect } from "react";

import SwiperCore, {Autoplay, Navigation, Pagination} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
SwiperCore.use([Navigation, Pagination, Autoplay]);
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import {  useTranslation } from 'next-i18next';

import styles from './VerzelDna.module.scss'

import DifferenceCard from "./DifferenceCard/DifferenceCard";

const bulletsStyles = {
    "--swiper-pagination-bullet-horizontal-gap": "1.025vw",
    "--swiper-pagination-bullet-vertical-gap": "2vw",
    "--swiper-pagination-bullet-width": "1.538vw",
    "--swiper-pagination-bullet-height": "1.538vw",
    "--swiper-pagination-bullet-color": "red",
    "--swiper-pagination-bullet-active-color": "#9FE870", 
    "--swiper-pagination-bullet-inactive-color": "#9FE870",
    "--swiper-theme-color": "#9FE870",
}

const VerzelDna = () => {
    const { t } = useTranslation();
    const [mobileMode, setMobileMode] = useState(false);

    const FIELDS_INPUTS = {
        title: t('ourDifferentials.title'),
        cards: [
            {   
                id: 1,
                icon: '/landings/assets/icons/certificate.svg',
                title: t('ourDifferentials.brilliantPeople'),
                text: t('ourDifferentials.text-1'),
            },
            {
                id: 2,
                icon:'/landings/assets/icons/eco.svg',
                title: t('ourDifferentials.ecosystem'),
                text: t('ourDifferentials.text-2'),
            },
            {
                id: 3,
                icon: '/landings/assets/icons/hand-shake.svg',
                title: t('ourDifferentials.commitmentToDelivery'),
                text: t('ourDifferentials.text-3'),
            },
        ]
    }

    const cards = (FIELDS_INPUTS && FIELDS_INPUTS.cards) || []

    useEffect(() => {
        function handleResize() {
            const currentWidth = window.innerWidth;
            setMobileMode(currentWidth <= 1024);
        }

        setMobileMode(window.innerWidth <= 1024);
    
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.line}></div>

            <div className={styles.title}>
                {FIELDS_INPUTS.title}
            </div>

            { 
                !mobileMode ? (
                    <div className={styles.cards}>
                        {
                            cards.map((card) => {
                                return (
                                    <DifferenceCard
                                        key={card.id}
                                        icon={card.icon}
                                        title={card.title}
                                        text={card.text}
                                    />
                                )
                            })
                        }
                    </div>
                ) : (
                    <Swiper
                        modules={[Pagination, Autoplay]}
                        slidesPerView={1}
                        loop
                        pagination={{
                            clickable: true,
                            type: "bullets"
                            
                        }}
                        autoplay={{ delay: 100000 }}
                        className={`${styles.custom_swiper}`}
                        style={bulletsStyles}
                        onSwiper={(swiper) => {
                            const paginationEl = swiper.pagination.el;

                            paginationEl.style.height="1.538vw"
                            paginationEl.style.display="flex"
                            paginationEl.style.justifyContent="center"
                        }}
                    >
                        {
                            cards.map((card) => {
                                return (
                                    <SwiperSlide key={card.id}>
                                        <DifferenceCard
                                            key={card.id}
                                            icon={card.icon}
                                            title={card.title}
                                            text={card.text}
                                        />
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>
                )
            }
        </div>
    )
}

export default VerzelDna;
